<template>
  <section class="collections-section">
    <div class="column has-background-white">
      <p class="has-text-centered">
        <strong>{{ instruction }}</strong>
      </p>
    </div>
    <div class="logo-container">
      <ul class="grid">
        <li
          v-for="(collection, index) in data"
          :key="index"
          :style="{
            backgroundImage: `url(${collection.logo})`,
            order: index,
          }"
          class="card"
          :class="
            this.selectedCompany.company === collection.company
              ? 'active'
              : null
          "
          @click="
            this.activeOrder = index;
            this.selectedCompany = collection;
          "
        >
          <p v-if="collection.logo === ''" class="no-logo-text">{{ collection.company }}</p>
          <div class="card-label">{{ collection.company }}</div>
        </li>
        <li
          v-if="this.selectedCompany"
          class="collection-info fullwidth"
          :style="{ order: activeOrder }"
        >
          <div class="collection-info-container">
            <div
              class="collection-info-logo"
              :style="{
                backgroundImage: `url(${this.selectedCompany.logo})`,
              }"
            >
              <p v-if="this.selectedCompany.logo === ''" class="no-logo-text">{{ this.selectedCompany.company }}</p>
            </div>
            <div class="collection-info-text">
              <h3 class="title is-5">{{ this.selectedCompany.company }}</h3>
              <p>{{ this.selectedCompany[language]}}</p>
              <a
                :href="this.selectedCompany.link"
                target="_blank"
                class="button is-primary mt-5"
                >{{ collectionButton }} <i class="fas fa-external-link-alt"></i
              ></a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    instruction: {
      type: String,
      default: null,
    },
    data: {
      type: Array,
      default: null,
    },
    collectionButton: {
      type: String,
      default: null,
    },
    language: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeOrder: "1",
      selectedCompany: "",
    };
  },
};
</script>

<style scoped>
/* -- Section -- */
.collections-section {
  padding: 0px 0 20px;
  background-color: var(--getty-grey-2);
}
/* -- Container-- */
.logo-container {
  padding: 40px 20px 20px;
}

/* --Grid list-- */
.grid {
  padding: 0;
  margin: 0 auto;
  list-style-type: none;
  display: grid;
  gap: 20px;
  grid-auto-flow: dense;
  grid-template-columns: repeat(auto-fit, 120px);
  justify-content: center;
  max-width: 1540px;
}
.collection-info {
  background-color: #fff;
  background-color: var(--getty-grey-1);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid var(--getty-grey-3);
}

/* -- Logo cards -- */
.card {
  width: 120px;
  height: 120px;
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 75%;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card.active {
  border: 3px solid var(--getty-grey-3);
}
.card.active:before {
  content: "";
  position: absolute;
  border: 20px solid transparent;
  border-bottom: 20px solid var(--getty-grey-3);
  top: calc(100% - 15px);
  left: calc(50% - 20px);
}
.card.active:after {
  content: "";
  position: absolute;
  border: 16px solid transparent;
  border-bottom: 16px solid var(--getty-grey-1);
  top: calc(100% - 6px);
  left: calc(50% - 16px);
}
.card-label {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px;
  color: #fff;
  font-size: 12px;
  line-height: 1.2em;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  opacity: 0;
  border-radius: 0 0 3px 3px;
}
.card:hover .card-label {
  opacity: 1;
}

.no-logo-text {
  font-weight: 900;
  text-align: center;
  font-size: 1rem;
  line-height: 1.1rem;
  padding: 0 0.7rem;
}

/* -- Collection info -- */
/* make fullwidth card span all grid columns */
.fullwidth {
  grid-column: 1 / -1;
  padding: 35px 20px 30px;
}
.collection-info-container {
  max-width: 850px;
  display: flex;
}
.collection-info-logo {
  width: 100%;
  margin-right: 30px;
  min-width: 200px;
  max-width: 200px;
  background-position: center;
  background-size: 80%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}
.collection-info-logo .no-logo-text {
  font-size: 1.75rem;
  line-height: 2.1rem;
  padding: 0 0.75rem;
}
.collection-info-text {
  padding-left: 30px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}
.button svg {
  opacity: 0.5;
  margin-left: 7px;
}

@media (max-width: 734px) {
  .fullwidth {
    padding: 30px 20px 30px;
  }
  .collection-info-container {
    flex-direction: column;
  }
  .collection-info-logo {
    height: 120px;
    min-width: 120px;
    max-width: 120px;
    background-size: contain;
    margin: 0 auto 30px;
  }
  .collection-info-logo .no-logo-text {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }
  .collection-info-text {
    border-left: none;
    padding-left: 0;
    padding-top: 30px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>